// src/components/organism/WeatherNowDisplay.js
import React from 'react';
import Panel from '../atom/Panel';
import "./WeatherNowDisplay.css";
import HourlyForecast from '../molecules/HourlyForecast';
import SearchBar from '../molecules/SearchBar';
import WeatherIcon from '../atom/WeatherIcon';

const WeatherNowDisplay = ({ data, onSearch, error }) => {
  if (!data) return <p>Wetterdaten werden geladen...</p>;

  return (
    <Panel className="weather-now-display">
      <div className='topPart-searchBar'>
        <SearchBar onSearch={onSearch} />
{/* ❌ Fehleranzeige direkt unter der Suchleiste */}
{error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
      </div>
      
      <div className='middlePart-weatherNow'>
        <WeatherIcon type={data.weatherNow.conditionMapped} className="weatherIconNow"/>
        <div className='middlePart-temp'>{data.weatherNow.temperature}°</div>
        <div className='middlePart-text' style={{ textTransform: 'capitalize' }}>{data.weatherNow.conditionMapped}</div>
      </div>

      <div className="hourly-forecast-container">
        {data.forecastToday.hourlyToday.slice(0, 5).map((hourData, index) => (
          <HourlyForecast key={index} data={hourData} />
        ))}
      </div>
    </Panel>
  );
};


export default WeatherNowDisplay;

